import serviceProyectoUsuario from '@/services/GsEncuesta/proyectoUsuario'

export default {
  USUARIO_FIND_ALL_BY_PROYECTO(_, params) {
    return new Promise((resolve, reject) => {
      serviceProyectoUsuario.findAllByProyecto(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  USUARIO_PROYECTO_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceProyectoUsuario.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  USUARIO_PROYECTO_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceProyectoUsuario.deleteAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
